import React from 'react'
import { Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import UploadGedcomCard from './UploadGedcomCard'
import ManageTreeGroup from './ManageTreeGroup'
import { type ManageTreesSectionProps } from './manageTreesSectionProps'

/**
 * The original Manage Trees layout: family group trees, owned trees, and shared trees each in
 * their own card. Rendered when `treeWeb_manageTrees_combinedLists` is off.
 */

export default function ManageTreesListContent({
  canAccessFGT,
  failedFiles,
  familyGroupTreeGroups,
  isMobile,
  ownedTrees,
  processingFiles,
  sharedTrees,
  showTreesYouOwn,
  showUploadGedcomCard,
}: ManageTreesSectionProps): JSX.Element {
  const { t } = useTranslation()

  return (
    <Grid gutters="xs">
      {/* 1. Groups With Trees - Show if user has FGT groups */}
      {canAccessFGT && familyGroupTreeGroups.length > 0 && (
        <ManageTreeGroup
          groupTitle={t('tree-import.manage-trees.family-groups-heading')}
          groups={familyGroupTreeGroups}
          isMobile={isMobile}
        />
      )}

      {/* 2. Trees You Own - Show upload card or owned trees */}
      {showTreesYouOwn && showUploadGedcomCard && <UploadGedcomCard />}

      {showTreesYouOwn && !showUploadGedcomCard && (
        <ManageTreeGroup
          groupTitle={t('tree-import.manage-trees.owned-groups-heading')}
          groups={ownedTrees}
          isMobile={isMobile}
          showUploadButton
          processingFiles={processingFiles}
          failedFiles={failedFiles}
        />
      )}

      {/* 3. Trees Shared With You - Show if user has shared trees */}
      {sharedTrees.length > 0 && (
        <ManageTreeGroup
          groupTitle={t('tree-import.manage-trees.shared-groups-heading')}
          groups={sharedTrees}
          isMobile={isMobile}
        />
      )}
    </Grid>
  )
}
